<template>
  <header class="app-header navbar" ref="head">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-link class="navbar-brand" to="#"></b-link>
    <button class="navbar-toggler sidebar-toggler d-md-down-none mr-auto" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-navbar-nav class="ml-auto">
      <b-nav-item-dropdown v-if="isLogin" id="ddown-split" size="sm" split :text="loginName" variant="outline-primary" class="m-2">
        <b-dropdown-item href="#" @click="doLogout"><span class="fa fa-sign-out"></span> 注销</b-dropdown-item>
      </b-nav-item-dropdown>
      <b-nav-item v-else class="d-md-down-none" @click="doLogin">
        <span class="fa fa-sign-in"></span> 登录
      </b-nav-item>
      <b-nav-text>&emsp;</b-nav-text>
    </b-navbar-nav>
  </header>
</template>
<script>
import Error from '@/mixin/error'
import api from '@/utils/api'

export default {
  name: 'c-header',
  props: [],
  mixins: [Error],
  data () {
    return {}
  },
  computed: {
    isLogin: function () {
      return this.$store.getters.logined
    },
    loginName: function () {
      if (this.$store.getters.logined) {
        return '欢迎，' + this.$store.getters.loginInfo.name
      } else {
        return '未登录'
      }
    }
  },
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    doLogout (e) {
      e.preventDefault()
      window.location.href = api.getAdminLogout()
    },
    doLogin (e) {
      e.preventDefault()
      window.location.href = api.getAdminLogin()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Header.vue?371957d8